export default {
  INSERT_INTO_ALL: "INSERT_INTO_ALL_ROUNDING_AREA",
  ADD_TO_IN_PROGRESS: "ADD_TO_IN_PROGRESS_ROUNDING_AREA",
  INSERT_INTO_FORMS: "INSERT_INTO_FORMS_ROUNDING_AREA",
  DESTROY_FORM: "DESTROY_FORM_ROUNDING_AREA",
  SET_FORM_ERROR: "SET_FORM_ERROR_ROUNDING_AREA",
  UPDATE_FORM_INSTANCE: "UPDATE_FORM_INSTANCE_ROUNDING_AREA",
  INSERT_INTO_PAGINATION: "INSERT_INTO_PAGINATION_ROUNDING_AREA",
  INSERT_INTO_FILTERED: "INSERT_INTO_FILTERED_ROUNDING_AREA",
  RESET_STATE: "RESET_STATE_ROUNDING_AREA",
  CLEAR_FETCHED: "CLEAR_FETCHED_ROUNDING_AREA",
  REMOVE_FROM_IN_PROGRESS: "REMOVE_FROM_IN_PROGRESS_ROUNDING_AREA",

  LIST_URL: "/errands/components/roundingarea/list/",
  POST_URL: "/errands/components/roundingarea/",
  PATCH_URL: "/errands/components/roundingarea/",
  GET_URL: "/errands/components/roundingarea/",

  STORE_NAME: "roundingAreas",
};
